import React from "react";

const LoadingMore: React.FC = () => {
  return <div className="loadingIconWrapper">

    <div className="loadingIcon"></div>
    </div>
}

export default LoadingMore;